import { CalendarioAvances } from '../../../objetos/objeto_servicio';
import React, { useState } from 'react';
import { useisUserAdmin } from '../../../config/unificacion';
import { useUsers } from '../../../metodos/userContext';
import generarPdfCalendarioTesis from './vistas/generateCalendarioTesis';
import { CheckCircle, Download } from 'lucide-react';


const ModuloTesis = ({ servicio, onGuardarCalendario, solicitud, onGuardarServicio}) => {
    const {usuario} = useUsers();
    const isAdmin = useisUserAdmin(usuario);
    const valorInicial = servicio.objetoTesis.calendarioAvances;
    const calendarioSubido = valorInicial.length > 0;
    const [avances, setAvances] = useState(Array.isArray(valorInicial) ? valorInicial : []);
    const [nuevoDetalle, setNuevoDetalle] = useState('');
    const [nuevaFecha, setNuevaFecha] = useState('');

    const handleAgregarAvance = () => {
        if (!nuevoDetalle || !nuevaFecha) {
            alert('Por favor, completa el detalle y la fecha del avance.');
            return;
        }
        const nuevoAvance = new CalendarioAvances({
            numeroAvance: avances.length + 1,
            detalle: nuevoDetalle,
            fechaEntrega: nuevaFecha,
        });
        setAvances([...avances, nuevoAvance]);
        setNuevoDetalle('');
        setNuevaFecha('');
    };

    const handleEliminarAvance = (indiceAEliminar) => {
        const avancesActualizados = avances
            .filter((_, index) => index !== indiceAEliminar)
            .map((avance, index) => ({ ...avance, numeroAvance: index + 1 }));
        setAvances(avancesActualizados);
    };

    const handleGuardar = () => {
        console.log("Datos a guardar:", avances);
        onGuardarCalendario(avances);
        //alert('Calendario guardado (simulación). Revisa la consola para ver los datos.');
    };

    const CardListasAvances = ({ }) => {
        return (
            <>
                {/* Lista de avances agregados */}
                <div className="space-y-3">
                    <h3 className="text-lg font-semibold text-gray-700">Avances Programados</h3>
                    {avances.length > 0 ? (
                        avances.map((avance, index) => (
                            <div key={index} className="flex items-center justify-between p-3 bg-white rounded-lg shadow-sm border">
                                <div className="flex items-center gap-4">
                                    <span className="flex items-center justify-center h-8 w-8 bg-indigo-100 text-indigo-700 font-bold rounded-full">{avance.numeroAvance}</span>
                                    <div>
                                        <p className="font-medium text-gray-900 whitespace-pre-wrap">{avance.detalle}</p>
                                        <p className="text-sm text-gray-500">Fecha: {avance.fechaEntrega}</p>
                                    </div>
                                </div>
                                {!calendarioSubido && (
                                    <button 
                                    onClick={() => handleEliminarAvance(index)}
                                    className="text-red-500 hover:text-red-700 font-medium"
                                >
                                    Eliminar
                                </button>
                                )}
                                
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500 italic text-center py-4">No hay avances programados todavía.</p>
                    )}
                </div>
                
                {!calendarioSubido && (
                    <div className="mt-8 text-center">
                    <button
                        onClick={handleGuardar}
                        className="w-full md:w-auto px-8 py-3 bg-green-600 text-white font-bold rounded-lg hover:bg-green-700 transition-colors shadow-lg"
                    >
                        Guardar Calendario Completo
                    </button>
                </div>
                )}
                
            </>
        );
    }


    return (
    <div className="p-6 bg-gray-50 rounded-lg">

        <h2 className="text-2xl font-bold text-gray-800 mb-6">Calendario de Avances</h2>

        <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200 mb-8">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Estado Actual de la Tesis</h3>
            <p className="text-3xl font-bold text-blue-600 mt-2 flex items-center gap-3">
                {/* CAMBIO: Usamos el icono CheckCircle de Lucide */}
                <CheckCircle className="text-green-500" size={32} />
                    <span>{servicio.getAvanceGeneral().tutor}</span>
                </p>
                <p className="text-sm text-gray-500 mt-2">
                    Este espacio es para que propongas el calendario de avances, ten en cuenta la fecha final y la fecha de inicio de la tesis.
                    Ojo, pregúntale al administrador que te agendó cuántos números de avances tendrá esta tesis.
                </p>
        </div>

        {calendarioSubido ? (
            <div>

                
                <CardListasAvances
                    avances={avances}
                    handleEliminarAvance={handleEliminarAvance}
                    handleGuardar={handleGuardar}
                />

                {/* Panel de Acciones para Administradores */}
                {isAdmin && (
                    <div className="mt-8 pt-6 border-t border-gray-200 flex flex-col md:flex-row items-center justify-end gap-4">
                        {/* Botón Generar PDF */}
                        <button
                            onClick={() => generarPdfCalendarioTesis(servicio, solicitud)}
                            className="w-full md:w-auto flex items-center justify-center gap-2 px-5 py-3 font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-100 transition-colors"
                            title="Generar PDF del cronograma"
                        >
                            {/* CAMBIO: Usamos el icono Download de Lucide */}
                            <Download size={20} />
                            <span>Generar PDF</span>
                        </button>

                        {/* Botón Aprobar y Enviar */}
                        <button
                            onClick={() => onGuardarServicio('objetoTesis.calendarioEnviadoACliente', true)}
                            disabled={servicio.objetoTesis.calendarioEnviadoACliente}
                            className={`w-full md:w-auto px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium shadow-md ${
                                !servicio.objetoTesis.calendarioEnviadoACliente
                                    ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer'
                                    : 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                }`}
                        >
                            {/* CAMBIO: Usamos el icono CheckCircle de Lucide */}
                            <CheckCircle size={20} />
                            <span>
                                {servicio.objetoTesis.calendarioEnviadoACliente
                                    ? 'Calendario Enviado'
                                    : 'Aprobar y Enviar'}
                            </span>
                        </button>
                    </div>
                )}
            </div>
        ) : (
            <>
                {/* Formulario para agregar nuevos avances */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 p-4 border rounded-lg bg-white">
                            <div className="md:col-span-2">
                                <label htmlFor="detalle" className="block text-sm font-medium text-gray-700">Detalle del Avance</label>
                                {/* 👇 REEMPLAZA <input> POR <textarea> 👇 */}
                                <textarea
                                    id="detalle"
                                    value={nuevoDetalle}
                                    onChange={(e) => setNuevoDetalle(e.target.value)}
                                    rows="3" // Puedes añadir 'rows' para definir la altura inicial
                                    placeholder="Ej: Entrega del Capítulo 1 y 2, incluyendo correcciones del tutor..."
                                    className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>
                            <div>
                                <label htmlFor="fecha" className="block text-sm font-medium text-gray-700">Fecha de Entrega</label>
                                <input
                                    type="date"
                                    id="fecha"
                                    value={nuevaFecha}
                                    onChange={(e) => setNuevaFecha(e.target.value)}
                                    className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>
                            <div className="md:col-span-3 text-right">
                                <button
                                    onClick={handleAgregarAvance}
                                    className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                                >
                                    + Agregar Avance
                                </button>
                            </div>
                        </div>

                        <CardListasAvances 
                                avances={avances}
                                handleEliminarAvance={handleEliminarAvance}
                                handleGuardar={handleGuardar}
                            />
                        
            </>
        )}
    </div>
    );

};

export default ModuloTesis
